{
  "version": 1,
  "asset_id": "fb7775bd-ad35-4598-909a-6cb2d366c197",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/fb7775bd-ad35-4598-909a-6cb2d366c197/apn.webp",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/fb7775bd-ad35-4598-909a-6cb2d366c197/apn.webp",
  "original_filename": "apn.webp",
  "size": 7400,
  "content_type": "image/webp",
  "created_at": "2026-06-26T16:55:03Z"
}
